import type { FC } from 'react';
import { Button } from '@george-labs.com/design-system';

import type { Account } from '@shared/products-types';
import { t } from '@luna/i18n';
import { georgeStats } from '@shared/statistics';
import { useActiveProduct } from '@shared/products-core';

import { useDashboardAppearanceChange } from './hooks/useDashboardAppearanceChange';

export const DashboardAppearanceChange: FC = () => {
    const { additionalData } = useActiveProduct<Account>();

    const { hideAccountOnOverview, showAccountOnOverview } = useDashboardAppearanceChange();

    if (additionalData?.hidden === undefined) {
        return null;
    }

    if (additionalData?.hidden) {
        return (
            <Button
                className="g-inverted"
                icon={Button.ICON.SHOW_ON}
                size={Button.SIZE.SMALL}
                data-cy="account-settings-personalise-show-on-overview-button"
                onClick={() => {
                    georgeStats.trackEvent('productSettings', 'showAccountOnOverviewIconClicked');
                    showAccountOnOverview();
                }}
            >
                {t('app.showOverview')}
            </Button>
        );
    }

    return (
        <Button
            className="g-inverted"
            icon={Button.ICON.SHOW_OFF}
            size={Button.SIZE.SMALL}
            data-cy="account-settings-personalise-hide-on-overview-button"
            onClick={() => {
                georgeStats.trackEvent('productSettings', 'hideAccountOnOverviewIconClicked');
                hideAccountOnOverview();
            }}
        >
            {t('app.hideOverview')}
        </Button>
    );
};
